import { useState, useEffect } from 'react';
import { AppModal } from '@/components/ui/app-modal';
import { Button } from '@/components/ui/button';
import { Bell } from 'lucide-react';

const ASKED_KEY = 'notification_permission_asked';

export function NotificationPermissionDialog() {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail;
      setTitle(detail.title);
      setBody(detail.body);
      setOpen(true);
    };

    window.addEventListener('show-notification-permission', handler);
    return () => window.removeEventListener('show-notification-permission', handler);
  }, []);

  const handleAllow = async () => {
    setOpen(false);

    const { LocalNotifications } = await import('@capacitor/local-notifications');
    await LocalNotifications.requestPermissions();

    const { Preferences } = await import('@capacitor/preferences');
    await Preferences.set({ key: ASKED_KEY, value: 'true' });
  };

  const handleLater = () => {
    setOpen(false);
  };

  return (
    <AppModal
      open={open}
      onOpenChange={setOpen}
      title={
        <div className="flex flex-col items-center">
          <div className="flex justify-center mb-4">
            <div className="p-3 bg-primary/10 rounded-full">
              <Bell className="h-8 w-8 text-primary" />
            </div>
          </div>
          <span className="text-center">{title}</span>
        </div>
      }
      description={<span className="text-center block">{body}</span>}
      footer={
        <div className="flex flex-col space-y-2 w-full">
          <Button onClick={handleAllow} className="w-full">
            通知を許可する
          </Button>
          <Button variant="outline" onClick={handleLater} className="w-full">
            あとで
          </Button>
        </div>
      }
    />
  );
}
